const DD_EMOJI_MAP = [
    '[微笑]',
    '[撇嘴]',
    '[色]',
    '[发呆]',
    '[得意]',
    '[流泪]',
    '[害羞]',
    '[闭嘴]',
    '[睡]',
    '[大哭]',
    '[尴尬]',
    '[发怒]',
    '[调皮]',
    '[呲牙]',
    '[惊讶]',
    '[难过]',
    '[囧]',
    '[抓狂]',
    '[吐]',
    '[偷笑]',
    '[愉快]',
    '[白眼]',
    '[傲慢]',
    '[困]',
    '[惊恐]',
    '[流汗]',
    '[大笑]',
    '[悠闲]',
    '[奋斗]',
    '[咒骂]',
    '[疑问]',
    '[嘘]',
    '[晕]',
    '[衰]',
    '[骷髅]',
    '[敲打]',
    '[再见]',
    '[擦汗]',
    '[抠鼻]',
    '[鼓掌]',
    '[坏笑]',
    '[左哼哼]',
    '[右哼哼]',
    '[哈欠]',
    '[鄙视]',
    '[委屈]',
    '[快哭了]',
    '[阴险]',
    '[亲亲]',
    '[可怜]',
    '[高兴]',
    '[嘿哈]',
    '[耶]',
    '[笑哭]',
    '[捂脸]',
    '[机智]',
    '[皱眉]',
    '[奸笑]',
    '[吃瓜]',
    '[糗大了]',
    '[戳脸]',
    '[偷看]',
    '[无奈]',
    '[口罩]',
    '[惊吓]',
    '[思考]',
    '[吐血]',
    '[捂眼]',
    '[摸头]',
    '[打脸]',
    '[惊呆]',
    '[刀]',
    '[啤酒]',
    '[咖啡]',
    '[饭]',
    '[猪头]',
    '[玫瑰]',
    '[凋谢]',
    '[嘴唇]',
    '[爱心]',
    '[心碎]',
    '[蛋糕]',
    '[炸弹]',
    '[便便]',
    '[月亮]',
    '[太阳]',
    '[拥抱]',
    '[强]',
    '[弱]',
    '[握手]',
    '[胜利]',
    '[抱拳]',
    '[OK]',
    '[祈祷]',
    '[加油]',
    '[庆祝]',
    '[礼物]',
    '[红包]',
    '[蜡烛]',
    '[灯泡]'
]

const HD_EMOJI_MAP = [
    '[ 微笑 ]',
    '[ 撇嘴 ]',
    '[ 色 ]',
    '[ 发呆 ]',
    '[ 得意 ]',
    '[ 流泪 ]',
    '[ 害羞 ]',
    '[ 闭嘴 ]',
    '[ 睡 ]',
    '[ 大哭 ]',
    '[ 尴尬 ]',
    '[ 发怒 ]',
    '[ 调皮 ]',
    '[ 呲牙 ]',
    '[ 惊讶 ]',
    '[ 难过 ]',
    '[ 囧 ]',
    '[ 抓狂 ]',
    '[ 吐 ]',
    '[ 偷笑 ]',
    '[ 愉快 ]',
    '[ 白眼 ]',
    '[ 傲慢 ]',
    '[ 困 ]',
    '[ 惊恐 ]',
    '[ 流汗 ]',
    '[ 大笑 ]',
    '[ 悠闲 ]',
    '[ 奋斗 ]',
    '[ 咒骂 ]',
    '[ 疑问 ]',
    '[ 嘘 ]',
    '[ 晕 ]',
    '[ 衰 ]',
    '[ 骷髅 ]',
    '[ 敲打 ]',
    '[ 再见 ]',
    '[ 擦汗 ]',
    '[ 抠鼻 ]',
    '[ 鼓掌 ]',
    '[ 坏笑 ]',
    '[ 左哼哼 ]',
    '[ 右哼哼 ]',
    '[ 哈欠 ]',
    '[ 鄙视 ]',
    '[ 委屈 ]',
    '[ 快哭了 ]',
    '[ 阴险 ]',
    '[ 亲亲 ]',
    '[ 可怜 ]',
    '[ 高兴 ]',
    '[ 嘿哈 ]',
    '[ 耶 ]',
    '[ 笑哭 ]',
    '[ 捂脸 ]',
    '[ 机智 ]',
    '[ 皱眉 ]',
    '[ 奸笑 ]',
    '[ 吃瓜 ]',
    '[ 糗大了 ]',
    '[ 戳脸 ]',
    '[ 偷看 ]',
    '[ 无奈 ]',
    '[ 口罩 ]',
    '[ 惊吓 ]',
    '[ 思考 ]',
    '[ 吐血 ]',
    '[ 捂眼 ]',
    '[ 摸头 ]',
    '[ 打脸 ]',
    '[ 惊呆 ]'
]

//表情图片转文字
const REG_Emoji2Word = /<img[^<]+[src=".*"]?title=['"]([^<]+?)['"] class=['"]emoji emoji(\d+)['"] type=['"]([^<]+?)['"][^<]*>([\r\n]|[\s])?/g;

function Emoji2Word(str) {
    if (typeof str != 'string') return;
    return str.replace(REG_Emoji2Word, function () {
        //匹配表情EMOJI_MAP
        if (arguments[3] === 'dangdang') {
            return DD_EMOJI_MAP[arguments[2]]
        }
        if (arguments[3] === 'emoji') {
            return HD_EMOJI_MAP[arguments[2]]
        }
    })
}

//文字转表情图片
const REG_Word2Emoji = /\[ ?([\u4e00-\u9fa5]+|OK) ?\]?/g;

function Word2Emoji(str) {
    if (typeof str != 'string') return;
    return str.replace(REG_Word2Emoji, function () {
        var dd_index = DD_EMOJI_MAP.indexOf(arguments[0]);
        if (dd_index !== -1) {
            return '<img src="http://s1.im-dangdang.com/online/20171204/ddTdnJ5Bfy.png" title="' + arguments[0] + '" class="emoji emoji' + dd_index + '" type="dangdang">'
        }
        var hd_index = HD_EMOJI_MAP.indexOf(arguments[0]);
        if (hd_index !== -1) {
            return '<img src="http://s1.im-dangdang.com/online/20171204/ddTdnJ5Bfy.png" title="' + arguments[0] + '" class="emoji emoji' + hd_index + '" type="emoji">'
        }
        return arguments[0]
    })

}

export default {
    Emoji2Word,
    Word2Emoji
}
